import { render, staticRenderFns } from "./VolunteerSche.vue?vue&type=template&id=22b3cebe&scoped=true"
import script from "./VolunteerSche.vue?vue&type=script&lang=js"
export * from "./VolunteerSche.vue?vue&type=script&lang=js"
import style0 from "./VolunteerSche.vue?vue&type=style&index=0&id=22b3cebe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b3cebe",
  null
  
)

export default component.exports